import { PET_CONSTANTS } from '@flows/configs/petHealth/constants'
import type { TextContent } from '@flows/core/i18n/types'
import type { TransformedNoContentOption } from '@flows/core/types/stepContentTypes'

export const getBreedWithTranslatableUnknown = (breed: string): TransformedNoContentOption => {
  let label: TextContent = {
    type: 'nonTranslatableText',
    text: breed,
  }

  if (breed === PET_CONSTANTS.unknownOption) {
    label = {
      type: 'translatableText',
      translationKey: 'sharedFlows_petHealth:steps.pure_breed_name.breed.unknown',
    }
  }

  return {
    value: breed,
    label,
  }
}
